<template>
    <div id="aplicpage">
        <div id="toolH">
            <div  class="flex_b head">
                <h4>{{$t('saleOrder_list_of_billing_applications')}}</h4>
                <i class="el-icon-close" @click="closecontent"></i>
            </div>
            <div class="flex_b padTB6" style="margin: 3px 9px 0px 9px;">
                <el-input  @clear="clearsearch('sou')" class=""   v-model="vc_search" :placeholder="$t('button_search_for')" clearable size="small"></el-input>
                <el-button  icon="el-icon-search" circle  size="mini" @click="gosearch"></el-button>
            </div>
        </div>
        <div class="scrollview" v-loading="loading"  :style="'height: '+tableHeight+'px'">
            <div class="borderadis"  v-for="(item,index) in tableData" :key="index">
                <div class="flex_b">
                    <div>
                        <div class="flex alc">
                            <div class="boxyu box marr5" v-if="item.i_isdirect==1">{{$t('form_direct')}}</div>
                            <div class="boxyu box marr5" v-else-if="item.i_ispresale==1">{{$t('form_pre')}}</div>
                            <div :class="[baseerp+'color','marr5','W700']">{{'['+item.vc_gsname+']'}}</div>
                            <div :class="['W700']">{{item.i_lxdid}}</div>
                        </div>
                        <div class="flex alc">
                            <div class="greyfont marr5">{{$t('form_pustomer')}}</div>
                            <div class="blackfont">{{item.vc_khname}}</div>
                        </div>
                    </div>
                    <el-button @click="openKd(item)" :class="baseerp+'btn'" class="kd" size="small" type="primary">{{$t('saleOrder_billing')}}</el-button>
                </div>
                <div class="flex_b alc">
                    <div class="flex alc">
                        <div class="greyfont marr5">{{$t('form_drawer')}}</div>
                        <div class="blackfont">{{item.vc_kduname}}</div>
                    </div>
                    <div class="greyfont">{{item.dt_createtime}}</div>
                </div>
                <div class="sub" v-for="(subitem,subindex) in item.list" :key="'sub'+subindex">
                    <div class="flex_b marb3">
                        <div class="blackfont">{{subitem.vc_pzname}}</div>
                        <div class="blackfont">{{'x '+subitem.f_num+' '+subitem.vc_unit}}</div>
                    </div>
                </div>
            </div>
        </div>
        <el-pagination
                class="fr mrr9"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[15, 20, 30]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
    </div>
</template>


<script>
    import { Loading} from 'element-ui';
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "pendingList",
        components: {
        },
        props:{

        },
        data() {
            return {
                mid:0,
                loading:true,
                vc_search:'',
                tableData:[],
                pageSize:15,
                currentPage:1,
                tableTotal:0,
                tableHeight:0,
                baseerp:"",
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
            /*appdata: {
                handler() {
                    if (this.appdata) {
                        //console.log("vc_orderno变了",this.appdata.vc_orderno);
                        this.vc_orderno=this.appdata.vc_orderno;
                        this.row=this.appdata.row;
                        this.sqlist();
                    }
                },
                immediate: true,
                deep: true
            }*/
        },
        /*activated(){
            this.onResize();
        },*/
        mounted() {
            this.baseerp=baseerp;
            this.getList(0);
            this.$nextTick(function () {
                this.onResize();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight= n.h-120;
                //console.log(n.h,this.tableHeight)
            },
            openKd(item){
                this.$emit('getListid',item,'LXD')
            },
            closecontent(){
                this.$emit('closeTree')
            },
            gosearch(){
                this.currentPage=1;
                this.tableData=[];
                this.getList(0);
            },
            clearsearch(type){
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";

                }else if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList(0);
            },
            //列表list
            async getList(type){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    "i_gsid": this.companyId,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                };
                //console.log('调接口',type,this.vc_search,this.companyId);
                //return;
                if(type==0){
                    var res = await API.getLxdList(param);
                }else if(type==1){
                    var res = await API.listTd(param);
                }
                if (res.code==1){
                    res.data.list.map(item=>{
                        let hush=[];
                        hush.push(item.list[0]);
                        item.showpzlist=hush;
                        item.pzlen=item.list.length;
                    })
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    this.loading=false;
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList(0);
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList(0);
            },


        },
    }
</script>

<style  lang="scss" scoped>

    .box{
        width: 14px;
        height: 18px;
        line-height: 18px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .greyfont{
        color: #808080;
        font-size: 14px;
    }
    .blackfont{
        color: #393c40;
        font-size: 14px;
    }
    .W700{
        font-weight: 700 !important;
    }
    .padTB6{
        padding: 6px 0;
    }


    .scrollview{
        overflow: auto;
    }
    .marbtn{
        margin: 3px 0 0 9px;
    }
    .txtc{
        text-align: center;
    }
    .shenpi{
        color:#f08c00;
        font-size: 14px;
        font-weight: 700;
    }
    .red{
        color:#fa5050;
        font-size: 14px;
        font-weight: 700;
    }
    .complete{
        color:#3cb44b;
        font-size: 14px;
        font-weight: 700;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .alc{
        align-items: center;
    }
    .sub{
        background-color: #efefef;
        padding: 4px;
    }
    .borderadis{
        border: 3px solid #efefef;
        border-radius: 8px;
        margin: 3px 9px 0px 9px;
        padding: 14px;
    }
    .marb3{
        margin-bottom: 3px;
    }
    .border{
        border-bottom: 1px  solid #efefef;
    }
    .marr5{
        margin-right: 5px;
    }
    .disB{
        display: block;
    }
    .wid30{
        width: 30%;
    }
    .wid50{
        width: 50%;
    }
    .wid100{
        width: 100%;
    }
    .text {
        font-size: 12px;
    }

    .item {
        padding: 9px 0;
        margin-right: 0px;
    }

    .box-card {
        //width: 480px;
        width: 100%;
        border-radius: 18px;
        margin-top: 10px;
    }
    .flex{
        display: flex;
    }
    .wid60{
        max-width: 60px;
        min-width: 60px;
    }
    .ghwcolor{
        color:#3e82e8;
        font-weight: 500;
        font-size: 16px;
    }
    .havaycolor{
        color: #e8c984;
        font-weight: 500;
        font-size: 16px;
    }
    .head{
        height: 30px !important;
    }
    </style>